<template>
  <div>
    <title_header :title="headerTitle" />
    <div class="news_box">
      <div class="flex box_flex">
        <div class="box_left">
          <title_list_component
            :title="title"
            :titleList="titleList"
            @changeIndex="changeIndex"
          />
          <customer class="margin_top" :info="info" />
        </div>
        <div class="box_right">
          <div class="ta-center fz24">联系我们</div>
          <div class="flex mt20 jc-sb">
            <div>
              <el-carousel height="360px">
                <el-carousel-item v-for="(item, index) in list" :key="index">
                  <img :src="item.picture" />
                </el-carousel-item>
              </el-carousel>

              <div class="citydizhi">
                <strong>{{ info.remark }}</strong>
                <p>公司地址：{{ info.content }}</p>
                <p>联系电话：{{ info.title }}</p>
              </div>
            </div>
            <div id="baidumap" class="citymap"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import title_header from "../../components/title_header";
import title_list_component from "../../components/title_list_component";
import customer from "../../components/customer";

export default {
  components: {
    title_header,
    title_list_component,
    customer,
  },
  props: { info: Object },
  data() {
    return {
      list: [],
      title: "公司信息",
      headerTitle: "联系我们",
      titleList: [{ name: "联系我们" }],
      contentDetail: {
        title: "关于我们",
        content: "弘者，光大也，弘",
      },
      bigImg: [
        "https://t7.baidu.com/it/u=3165657288,4248157545&fm=193&f=GIF",
        "https://t7.baidu.com/it/u=2942499027,2479446682&fm=193&f=GIF",
        "https://t7.baidu.com/it/u=2610975262,3538281461&fm=193&f=GIF",
        "https://t7.baidu.com/it/u=4138158235,3956816634&fm=193&f=GIF",
      ],
      galleryThumbs: null,
    };
  },
  watch: {
    info: {
      handler(val) {
        this.list = val.wxSchoolPageItemList;
        this.init();
      },
      deep: true,
    },
  },
  mounted() {
    this.init();
    this.list = this.info.wxSchoolPageItemList;
  },
  methods: {
    init() {
      let abscissa = this.info.abscissa.split(",")[0] || 120.306544;
      let ordinate = this.info.abscissa.split(",")[1] || 31.583588;
      var map = new BMap.Map("baidumap");
      map.centerAndZoom(new BMap.Point(abscissa, ordinate), 18);
      var marker1 = new BMap.Marker(new BMap.Point(abscissa, ordinate)); // 创建标注
      map.addOverlay(marker1); // 将标注添加到地图中
      //marker1.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
      //创建信息窗口
      var infoWindow1 = new BMap.InfoWindow(
        `<b>代谋培训</b><br>电话：${this.info.title}<br/>地址：${this.info.content}`
      );
      marker1.openInfoWindow(infoWindow1);
      marker1.addEventListener("click", function () {
        this.openInfoWindow(infoWindow1);
      });
      //向地图中添加缩放控件
      var ctrl_nav = new BMap.NavigationControl({
        anchor: BMAP_ANCHOR_TOP_LEFT,
        type: BMAP_NAVIGATION_CONTROL_LARGE,
      });
      map.addControl(ctrl_nav);
      //向地图中添加缩略图控件
      var ctrl_ove = new BMap.OverviewMapControl({
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        isOpen: 1,
      });
      map.addControl(ctrl_ove);
      //向地图中添加比例尺控件
      var ctrl_sca = new BMap.ScaleControl({
        anchor: BMAP_ANCHOR_BOTTOM_LEFT,
      });
      map.addControl(ctrl_sca);

      map.enableDragging(); //启用地图拖拽事件，默认启用(可不写)
      map.enableScrollWheelZoom(); //启用地图滚轮放大缩小
      map.enableDoubleClickZoom(); //启用鼠标双击放大，默认启用(可不写)
      map.enableKeyboard(); //启用键盘上下左右键移动地
    },
    changeIndex(item) {
      this.headerTitle = item.name;
    },
  },
};
</script>

<style lang="less" scoped>
.news_box {
  background-color: #ffffff;
  /*width: 1200px;*/
  margin: auto;
}

.box_flex {
  /*display: flex;*/
  margin-left: calc(50% - 600px);
  width: 1200px;
}

.margin_top {
  margin-top: 20px;
}

.box_left {
  padding: 10px;
  width: 300px !important;
  flex-shrink: 0;
}

.box_right {
  width: 100%;
  padding: 10px;
}

.box_pagination {
  text-align: center;
}

.citymap {
  width: 500px;
  height: 500px;
}

.swiper-container {
  background-color: #000;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
.citydizhi {
  margin-top: 16px;
  padding: 20px;
  box-sizing: border-box;
  height: 124px;
  background: #f5f5f5;
  width: 350px;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/designPage/template/module/module3/index.vue